/**
 * A HOC wrapping React Link Component. Used to unify the styles across all of our buttons.
 */
import { get } from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from 'tss-react/mui';

const styles = (theme) => ({
  root: {
    color: get(theme, 'palette.primary.main'),
    fontWeight: 'bold',
  },
});

const ReusableButton = withStyles((props) => {
  const { classes } = props;

  return <Link className={classes.root} {...props} />;
}, styles);

export default ReusableButton;
